import React, { FunctionComponent } from "react"
import { Table } from "react-bootstrap"
import HRRViewReportTableHeader from "./HRRViewReportTableHeader/HRRViewReportTableHeader"
import HRRViewReportTableBody from "./HRRViewReportTableBody/HRRViewReportTableBody"
import "./HRRViewReportTable.css"


const HRRViewReportTable: FunctionComponent<{}> = () => {

    return (
        <div className="HRRViewReportTable">
            <Table id="hrr-view-report-table" striped bordered>
                <HRRViewReportTableHeader />
                <HRRViewReportTableBody />
            </Table>
        </div>
    )
}

export default HRRViewReportTable